<template>
  <eg-dropdown
    :disabled="disabled"
    :text="value ? value.label : 'Platform'"
    :class="value ? 'platform-dropdown' : 'platform-dropdown all'"
  >
    <eg-b-dropdown-item
      v-for="(item, index) in platformDropdownItems"
      :key="`${item?.key}-${index}`"
      :value="item"
      :active="value?.key === item.key"
      @click="() => selectPlatform(item)"
    >
      <div class="item-wrapper">
        <span class="text-truncate paragraph-s">{{ item.label }}</span>
      </div>
    </eg-b-dropdown-item>
  </eg-dropdown>
</template>

<script>
import EgDropdown from "@/components/global/eg_dropdown";

export default {
  name: "PlatformDropdown",

  components: {
    EgDropdown,
  },
  inject: ["materialPlatforms"],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    platformDropdownItems() {
      const platforms = Object.values(this.materialPlatforms);

      return [
        {
          label: "All",
          key: "all",
        },
        ...platforms,
      ];
    },
  },

  methods: {
    selectPlatform(platform) {
      this.$emit("input", platform.key !== "all" ? platform : null);
    },
  },
};
</script>

<style lang="scss" scoped>
.platform-dropdown {
  width: 180px;
  max-width: 180px;

  &::v-deep {
    .btn {
      background-color: var(--color-surface-neutral-default);
      font-size: var(--typography-font-size-fs-300);
    }

    &.all {
      .btn {
        color: var(--color-text-neutral-disabled);
      }
    }
  }
}
</style>
